module.exports = __webpack_public_path__ + "static/img/gxfcye.70aa43f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gxfcye.png
// module id = FG8k
// module chunks = 0